<template>
  <div>
    <ProductAcceptance />
  </div>
</template>
<script>
import ProductAcceptance from "../procurement/ProductAcceptance.vue";
export default {
  components: {
    ProductAcceptance,
  },
};
</script>
